export default "__VITE_ASSET__sYTmAyRT__"